export default {
    'searchList': {
        'searchTxt': [{
            'name': '基础类型编码',
            'value': 'basicTypeCode',
            'type': 'input',
            'unfold': true,
            'span': 3,
        },
        {
            'name': '供应商类型',
            'value': 'supplierType',
            'type': 'select',
            'unfold': true,
            'span': 3,
            'optionNum': 'SYS_SUPPLIERS_TYPE',
            'multiple': false
        },
        {
            'name': '主体性质',
            'value': 'property',
            'type': 'select',
            'unfold': true,
            'span': 2,
            'optionNum': 'SYS_SUPPLIERS_PROPERTY',
        },
        {
            'name': '涉外业务类型',
            'value': 'isOverseas',
            'type': 'select',
            'unfold': true,
            'span': 2,
            'optionNum': 'SRM_IS_OVERSEAS',
        },
        {
            'name': '业务类型',
            'value': 'businessType',
            'type': 'select',
            'unfold': true,
            'span': 3,
            'optionNum': 'SRM_BUSYNESS_TYPE_BACKGROUND',
            'multiple': false
        },
        {
            'name': '状态',
            'value': 'typeStatus',
            'type': 'select',
            'unfold': true,
            'span': 2,
            'optionNum': 'SUPPLIER_TYPE_STATUS',
            'multiple': false
        },
        {
            'name': '承运商类别',
            'value': 'transType',
            'type': 'select',
            'unfold': true,
            'span': 3,
            'optionNum': 'SRM_SHIPPER_TYPE',
            'multiple': false
        },
        {
            'name': '运输方式',
            'value': 'transportType',
            'type': 'select',
            'unfold': true,
            'span': 3,
            'optionNum': 'SRM_TRANSPORT_TYPE',
            'multiple': false
        }
        ],
        'unfoldState': false,
        'advancedBtn': false
    },
    'table':
    {
        'clickState': false,
        'selectBtn': true,
        'height': 400,
        'columns': [
            {
                'label': '基础类型编码',
                'prop': 'basicTypeCode',
                'width': '150px'
            },
            {
                'label': '状态',
                'prop': 'typeStatus_',
                'width': '80px'
            },
            {
                'label': '供应商类型',
                'prop': 'supplierType_',
                'width': '200px'
            },
            {
                'label': '主体性质',
                'prop': 'property_',
                'width': '200px'
            },
            {
                'label': '涉外业务类型',
                'prop': 'isOverseas_',
                'width': '150px'
            },
            {
                'label': '业务类型',
                'prop': 'businessType_',
                'width': '200px'
            },
            {
                'label': '运输方式',
                'prop': 'transportType_',
                'width': '200px'
            },
            {
                'label': '承运商类别',
                'prop': 'transType_',
                'width': '200px'
            },
            {
                'label': '合作方式(其他)',
                'prop': 'cooperationWays_',
                'width': '200px'
            },
            {
                'label': '合作方式',
                'prop': 'corporateType_',
                'width': '200px'
            },
            {
                'label': '租赁商类别',
                'prop': 'lesseeType_',
                'width': '200px'
            },
            {
                'label': '司机数量',
                'prop': 'driverNumber',
                'width': '200px'
            },
            {
                'label': '车辆数量',
                'prop': 'vehiclesNumber',
                'width': '200px'
            }],
        'action':
            [
                {
                    'type': 'text',
                    'label': '标签',
                    'size': 'mini',
                    'event': 'configTab',
                    'ifHas': '04000106'
                },
                {
                    'type': 'text',
                    'label': '字段',
                    'size': 'mini',
                    'event': 'configField',
                    'ifHas': '04000107'
                },
                {
                    'type': 'text',
                    'label': '资质配置',
                    'size': 'mini',
                    'event': 'configQualification',
                    'ifHas': '04000108'
                }
            ],
        'leftOperation': true,
        'leftWidth': 170
    },
    'page': {
        'layout': 'total, sizes, prev, pager, next, jumper',
        'pageSize': 10
    }
};
